import { render, staticRenderFns } from "./menu-business-unit.component.vue?vue&type=template&id=ea838456&scoped=true&"
import script from "./menu-business-unit.component.vue?vue&type=script&lang=ts&"
export * from "./menu-business-unit.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu-business-unit.component.vue?vue&type=style&index=0&id=ea838456&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea838456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
